import React, { useEffect, useState } from 'react'
import FormProgress from '../components/FormProgress';
import { useTranslation } from 'react-i18next';
import { errorToast } from '../utils/errorHandling';
import { getAnnouncement } from '../services/studentApi';
import { Link } from 'react-router-dom';
import { AiOutlineLoading } from 'react-icons/ai';

const base_url = process.env.REACT_APP_BASE_URL;

const Home = () => {
  const [announcement, setAnnouncement] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation();

  const fetchAnnouncement = async () => {
    try {
      const res = await getAnnouncement();
      if (res.data) {
        setAnnouncement(res.data);
      }
    } catch (error) {
      errorToast(error, "Action Failed. Please contact admin", t);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    fetchAnnouncement();
  }, []);


  return (
    <>
      {/* <div className="welcome-banner">
        <h2>{t("Home.HealthDeclaration")}</h2>
        <div className="attendance-button-container">
          <Link to={`${base_url}/health_declaration`} className="attendance-button">
            {t("general.BTNsubmit")}
          </Link>
        </div>
        <p>{t("Home.WelcomeOffline")}</p>
        <p>{t("Home.HealthDescription", {date: "2025-03-25"})}</p>
      </div> */}
      <h4 className='homepage-title'>{t("Home.FormProgress")}</h4>
      <FormProgress />
      <h4 className='homepage-title'>{t("Home.Announcement")}</h4>
      <div className='movingCard'>
        <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
          <div className="carousel-indicators">
            {announcement.map((i, index) => (
              <button key={index} type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to={index} className={index === 0 ? "active" : ""} />
            ))}
          </div>
          <div className="carousel-inner">
            {isLoading ?
              <div className='d-flex justify-content-center'>
                <AiOutlineLoading className='spin m-6' />
              </div>
              :
              <>
                {
                  announcement.map((i, index) => (
                    <div className={index === 0 ? "carousel-item active" : "carousel-item"} key={index}>
                      <Link to={i.target_url || ""} target="_blank" rel="noopener noreferrer">
                        <div className="caption">
                          <h5 className='mb-0 mt-3'>☘️ {localStorage.getItem("i18nextLng") === "en" ? i.title_en : i.title_cn}</h5>
                          <p className='mb-0'> {localStorage.getItem("i18nextLng") === "en" ? i.description_en : i.description_cn}</p>
                        </div>
                        <img
                          src={i.image_url}
                          className="d-block w-100"
                          alt=""
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = `${base_url}/images/poster.jpg`
                          }}
                        />
                      </Link>
                    </div>
                  ))
                }
              </>
            }
          </div>
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
      <h4 className='homepage-title'>{t("Home.canvaMustKnow")}</h4>
      {localStorage.getItem("i18nextLng") === "en" ?
        <>
          <div className='canvaCard'>
            <iframe loading="lazy" className='canva'
              src="https://www.canva.com/design/DAGbsC-ex8g/E78rbDWfsN3j37r7F9hiyg/view?embed" allowFullScreen="allowfullscreen">
            </iframe>
          </div>
          <div className='canva-link'>
            <a href="https:&#x2F;&#x2F;www.canva.com&#x2F;design&#x2F;DAGbsC-ex8g&#x2F;E78rbDWfsN3j37r7F9hiyg&#x2F;view?utm_content=DAGbsC-ex8g&amp;utm_campaign=designshare&amp;utm_medium=embeds&amp;utm_source=link" target="_blank" rel="noopener">【Retreat Important Notice】The 3rd Malaysian Satipatthana Meditation Retreat</a>
          </div>
        </>
        :
        <>
          <div className='canvaCard'>
            <iframe loading="lazy" className='canva'
              src="https://www.canva.com/design/DAGbsKblj9c/SOJv1DML85WipYS5sB81dA/view?embed" allowFullScreen="allowfullscreen">
            </iframe>
          </div>
          <div className='canva-link'>
            <a href="https:&#x2F;&#x2F;www.canva.com&#x2F;design&#x2F;DAGbsKblj9c&#x2F;SOJv1DML85WipYS5sB81dA&#x2F;view?utm_content=DAGbsKblj9c&amp;utm_campaign=designshare&amp;utm_medium=embeds&amp;utm_source=link" target="_blank" rel="noopener">【課程須知】第三屆大馬四念處課程</a>
          </div>
        </>
      }
      <h4 className='homepage-title'>{t("Home.CanvaSlide")}</h4>
      {localStorage.getItem("i18nextLng") === "en" ?
        <>
          <div className='canvaCard'>
            <iframe loading="lazy" className='canva'
              src="https://www.canva.com/design/DAGbsL3AWTc/rf8gSzxSEL9HaaDWeN6P9Q/view?embed" allowFullScreen="allowfullscreen">
            </iframe>
          </div>
          <div className='canva-link'>
            <a href="https:&#x2F;&#x2F;www.canva.com&#x2F;design&#x2F;DAGbsL3AWTc&#x2F;rf8gSzxSEL9HaaDWeN6P9Q&#x2F;view?utm_content=DAGbsL3AWTc&amp;utm_campaign=designshare&amp;utm_medium=embeds&amp;utm_source=link" target="_blank" rel="noopener">【Notice of Acceptance】The 3rd Malaysian Satipatthana Meditation Retreat</a>
          </div>
        </>
        :
        <>
          <div className='canvaCard'>
            <iframe loading="lazy" className='canva'
              src="https://www.canva.com/design/DAGbrXBMjYU/IEypDAdfOAe5AWZUDXJkIw/view?embed" allowFullScreen="allowfullscreen">
            </iframe>
          </div>
          <div className='canva-link'>
            <a href="https:&#x2F;&#x2F;www.canva.com&#x2F;design&#x2F;DAGbrXBMjYU&#x2F;IEypDAdfOAe5AWZUDXJkIw&#x2F;view?utm_content=DAGbrXBMjYU&amp;utm_campaign=designshare&amp;utm_medium=embeds&amp;utm_source=link" target="_blank" rel="noopener">【錄取通知】2025 第三屆大馬四念處禪修課程 </a>
          </div>
        </>
      }
      <h4 className='homepage-title'>{t("Home.canvaRetreatSchedule")}</h4>
      {localStorage.getItem("i18nextLng") === "en" ?
        <>
          <div className='canvaCard'>
            <iframe loading="lazy" className='canva'
              src="https://www.canva.com/design/DAGbsPt8whQ/tFy6D59rty8kCcgRZPh68Q/view?embed" allowFullScreen="allowfullscreen">
            </iframe>
          </div>
          <div className='canva-link'>
            <a href="https:&#x2F;&#x2F;www.canva.com&#x2F;design&#x2F;DAGbsPt8whQ&#x2F;tFy6D59rty8kCcgRZPh68Q&#x2F;view?utm_content=DAGbsPt8whQ&amp;utm_campaign=designshare&amp;utm_medium=embeds&amp;utm_source=link" target="_blank" rel="noopener">【Retreat Schedule】2025 The 3rd Malaysian Satipatthana Meditation Retreat</a>
          </div>
        </>
        :
        <>
          <div className='canvaCard'>
            <iframe loading="lazy" className='canva'
              src="https://www.canva.com/design/DAGbsGEHbHc/aaKN0Tt_-BehQQp8yz2-_A/view?embed" allowFullScreen="allowfullscreen">
            </iframe>
          </div>
          <div className='canva-link'>
            <a href="https:&#x2F;&#x2F;www.canva.com&#x2F;design&#x2F;DAGbsGEHbHc&#x2F;aaKN0Tt_-BehQQp8yz2-_A&#x2F;view?utm_content=DAGbsGEHbHc&amp;utm_campaign=designshare&amp;utm_medium=embeds&amp;utm_source=link" target="_blank" rel="noopener">【課表與課程進行方式】2025 第三屆大馬四念處禪修課程</a>
          </div>
        </>
      }
      <h4 className='homepage-title'>{t("Home.canvaPreretreat")}</h4>
      {localStorage.getItem("i18nextLng") === "en" ?
        <>
          <div className='canvaCard'>
            <iframe loading="lazy" className='canva'
              src="https://www.canva.com/design/DAF7RSO7nCw/Q3DEaWL6wTCebD7KjrtrnA/view?embed" allowFullScreen="allowfullscreen">
            </iframe>
          </div>
          <div className='canva-link'>
            <a href="https:&#x2F;&#x2F;www.canva.com&#x2F;design&#x2F;DAF7RSO7nCw&#x2F;Q3DEaWL6wTCebD7KjrtrnA&#x2F;view?utm_content=DAF7RSO7nCw&amp;utm_campaign=designshare&amp;utm_medium=embeds&amp;utm_source=link" target="_blank" rel="noopener">【Pre-retreat Cultivations】2025 The 3rd Malaysian Satipatthana Meditation Retreat</a>
          </div>
        </>
        :
        <>
          <div className='canvaCard'>
            <iframe loading="lazy" className='canva'
              src="https://www.canva.com/design/DAGTI2I8lpc/4n7IKFofAnO61KqyHYraHQ/view?embed" allowFullScreen="allowfullscreen">
            </iframe>
          </div>
          <div className='canva-link'>
            <a href="https:&#x2F;&#x2F;www.canva.com&#x2F;design&#x2F;DAGTI2I8lpc&#x2F;4n7IKFofAnO61KqyHYraHQ&#x2F;view?utm_content=DAGTI2I8lpc&amp;utm_campaign=designshare&amp;utm_medium=embeds&amp;utm_source=link" target="_blank" rel="noopener">2025大馬課程-課前共修</a>
          </div>
        </>
      }
    </>
  )
}

export default Home